export default {"src":"/_next/static/media/vechtsporten.213ebf96.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};